import { CommandBar } from '@fluentui/react';
import { useTableCommandBarNearItems } from './useTableCommandBarNearItems';

/**
 * The command bar that appears above a search list table.
 */
export const SearchListTableCommandBar = () => {
  const nearItems = useTableCommandBarNearItems();

  const spacerId = nearItems.findIndex(i => i?.key === 'spacer') + 1;

  return (
    <>
      <CommandBar
        styles={{
          primarySet: {
            flexBasis: '12em',
            [`& :nth-child(${spacerId})`]: {
              display: 'flex',
              flexGrow: 1,
              flexShrink: 2,
            },
          },
          root: {
            boxShadow: 'unset',
            padding: '0 0.5em',
          },
        }}
        items={nearItems}
      />
    </>
  );
};
